import React, { Component } from 'react';

class Footer extends Component {
    render(){
        return (
            <footer className={"footer" + (this.props.transparent !== undefined ? " footer-transparent":"")}>
                <div className={"container" + (this.props.fluid !== undefined ? "-fluid":"")}>
                    <nav className="pull-left">
                        <ul>
                            {/*
                            <li>
                                <a href="/">
                                    Home
                                </a>
                            </li>
                            <li>
                                <a href="http://www.automatedenvironments.com/">
                                    Company Website (AEI)
                                </a>
                            </li>
                             <li>
                                <a href="#pablo">
                                    Portfolio
                                </a>
                            </li>
                            <li>
                                <a href="#pablo">
                                    Blog
                                </a>
                            </li> */}
                        </ul>
                    </nav>
                    {/* <p className="copyright pull-left">
                        &copy; {1900 + (new Date()).getYear()} <a href="http://www.automatedenvironments.com/">Barn365</a>
                    </p> */}
                </div>
            </footer>
        );
    }
}
export default Footer;
